import { useEffect } from "react";

// referred const instead of HOC since this is a hook
import { APPLICATION, INT_COUNTRY } from "@/constants";

export interface ExtendedWindow extends Window {
  dataLayer?: {
    event?: string;
    event_name?: string;
    trip_type?: string;
    destination?: string;
    destination_additions?: string;
    private_health_insurance?: boolean;
    trip_extra?: string;
    cover_start_date?: string;
    cover_end_date?: string;
    cruise?: boolean;
    travel_from?: string;
    travel_group_type?: string;
    page_url?: string;
    page_title?: string;
    step_name?: string;
    popup_name?: string;
  }[];
}

type QuestionSetProps = {
  pageTitle?: string;
  tripType?: string;
  pageUrl?: string;
  destination?: string;
  destinationAdditions?: string;
  privateHealthInsurance?: boolean;
  tripExtra?: string;
  coverStartDate?: string;
  coverEndDate?: string;
  cruise?: boolean;
  travelFrom?: string;
  travelGroupType?: string;
  isSubmitBtnClicked?: boolean;
};

const useGtmQuestionSet = (props: QuestionSetProps) => {
  const {
    pageTitle,
    tripType,
    pageUrl,
    destination,
    destinationAdditions,
    privateHealthInsurance,
    tripExtra,
    coverEndDate,
    coverStartDate,
    cruise,
    travelFrom,
    travelGroupType,
    isSubmitBtnClicked,
  } = props;

  useEffect(() => {
    const triggerQuestionSet = () => {
      const extendedWindow = window as ExtendedWindow;
      extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];
      const baseData: Record<string, string | boolean | undefined> = {
        event: "quote_journey",
        event_name: "quote_trip_details",
        trip_type: tripType,
        destination,
        destination_additions: destinationAdditions,
        trip_extra: tripExtra,
        cover_start_date: coverStartDate,
        cover_end_date: coverEndDate,
        travel_from: travelFrom,
        travel_group_type: travelGroupType,
        page_url: pageUrl,
        page_title: pageTitle,
        step_name: pageTitle,
      };

      // Only include private_medical_insurance if provided
      if (privateHealthInsurance !== undefined) {
        baseData.private_health_insurance = privateHealthInsurance;
      }

      // Only include cruise if provided
      if (cruise !== undefined && INT_COUNTRY) {
        baseData.cruise = cruise;
      }

      extendedWindow.dataLayer.push(baseData);
    };

    if (isSubmitBtnClicked === true && APPLICATION === "quote") {
      triggerQuestionSet();
    }

    return () => {
      // Cleanup if needed
    };
  }, [
    pageTitle,
    tripType,
    pageUrl,
    destination,
    destinationAdditions,
    privateHealthInsurance,
    tripExtra,
    coverEndDate,
    coverStartDate,
    cruise,
    travelFrom,
    travelGroupType,
    isSubmitBtnClicked,
  ]);
};

export default useGtmQuestionSet;
